import React from 'react';
import { motion } from 'framer-motion';
import { FaPause, FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

const MobileControls = ({ onPause, isMuted, onToggleMute }) => {
  return (
    // 改為垂直排列,避免與分數重疊
    <div className="fixed top-14 right-2 sm:top-16 sm:right-4 z-50 flex flex-col gap-1.5 sm:gap-2 pointer-events-auto">
      {/* Pause Button */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={onPause}
        className="w-10 h-10 sm:w-12 sm:h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center text-purple-600 active:bg-purple-100"
        aria-label="暫停遊戲"
      >
        <FaPause size={16} className="sm:w-[18px] sm:h-[18px]" />
      </motion.button>

      {/* Sound Toggle */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={onToggleMute}
        className="w-10 h-10 sm:w-12 sm:h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center text-purple-600 active:bg-purple-100"
        aria-label={isMuted ? '開啟音效' : '關閉音效'}
      >
        {isMuted ? (
          <FaVolumeMute size={16} className="sm:w-[18px] sm:h-[18px]" />
        ) : (
          <FaVolumeUp size={16} className="sm:w-[18px] sm:h-[18px]" />
        )}
      </motion.button>
    </div>
  );
};

export default MobileControls;